import BreadcrumbDatos from "./BreadcrumbDatos";
import { Form, Col, Row, Button, InputGroup, Alert } from "react-bootstrap";
import { getMarcas } from "../../services/MarcasService";
import { getProductos, deleteProduct } from "../../services/ProductosService";
import { useEffect, useState } from "react";
import MaoTable from "../common/MaoTable";
import { useNavigate, useSearchParams } from "react-router-dom";
import { formatNumber } from "../../utils/NumberUtils";
import { Cargando } from "../common/Cargando";
import { FaFilePdf } from "react-icons/fa6";
import { ButtonExportarExcel } from "../common/ButtonExportarExcel";

const api_excel = process.env.REACT_APP_HOME_URL+"/listaprecios/";
const api_pdf = process.env.REACT_APP_HOME_URL+"/listaprecios/pdf/";


export default function Productos() {

    let [searchParams, setSearchParams] = useSearchParams([]);
    const [marcas, setMarcas] = useState([]);
    const [error, setError] = useState("");
    const [productos, setProductos] = useState([]);
    const [marca, setMarca] = useState();
    const [nombreMarca, setNombreMarca] = useState("");
    const [nombre, setNombre] = useState();
    const [incluirInactivos, setIncluirInactivos] = useState(false);
    const [cargando, setCargando] = useState(false);

    const navigate = useNavigate();

    useEffect(() => {
        let marcaParam = searchParams.get('marca');
        if (marcaParam && marcaParam!=='') {
            setMarca(marcaParam);
        }
    }, []);

    useEffect(() => {
        getMarcas()
            .then((resp) => {
                if (resp.error) {
                    setError(resp.message);
                } else {
                    setMarcas(resp.data);
                }
            });
    }, [])

    const getNombreMarca = (id) => {
        for (let m in marcas) {
            if (m.marca_id===id)
                return "listaprecios-"+m.nombre;
        }
        return "";
    }

    useEffect(() => {
        if (marca && marca!="") {
            buscar(true);
            if (marcas && marcas.length>0)
                marcas.map((m) => {if (m.marca_id===marca) setNombreMarca(m.nombre)});
        } else {
            setError("");
            setProductos([]);
        }
    }, [marca, incluirInactivos]);

    async function buscar(noAlertMarca = false, marcaP = undefined) {
        setCargando(true);
        let marcaParam = marca;
        let nombreParam = nombre;
        let inactivosParam = incluirInactivos;
        if (marcaParam === undefined || marcaParam==="") {
            setError("");
            setProductos([]);
            if (!noAlertMarca)
                alert("Debe indicar una marca");
        } else {
            let resp = await getProductos(marcaParam, nombreParam, inactivosParam);
            setCargando(false);
            if (resp.error) {
                setError(resp.message);
                setProductos([]);
            } else {
                setError("");
                setProductos(resp.data);
            }
        }
    }

    function nuevo() {
        let marcaParam = document.getElementById("selMarca").value;
        if (marcaParam==="") {
            alert("Debe indicar una marca");
        } else {
            navigate("/productos/nuevo?marca="+marcaParam);
        }
    }

    function importar() {
        let marcaParam = document.getElementById("selMarca").value;
        if (marcaParam==="") {
            alert("Debe indicar una marca");
        } else {
            navigate("/productos/importar?marca="+marcaParam);
        }
    }

    function exportarExcel() {
        let marcaParam = document.getElementById("selMarca").value;
        if (marcaParam==="") {
            alert("Debe indicar una marca");
        } else {
            window.open(api_excel+marcaParam, '_blank'); 
        }
    }

    function exportarPDF() {
        let marcaParam = document.getElementById("selMarca").value;
        if (marcaParam==="") {
            alert("Debe indicar una marca");
        } else {
            window.open(api_pdf+marcaParam, '_blank'); 
        }
    }

    async function editar (id) {
        setSearchParams({"marca_id" : marca})
        navigate(`/productos/${id}`)
    }

    async function borrar(id) {
        const name = productos.find(x => x.producto_id === id).descripcion
        if (window.confirm("¿Esta seguro que quiere borrar el producto " + name + " ?")) {
            setCargando(true);
            const resp = await deleteProduct(id);
            setCargando(false);
            if (resp.error) {
                alert(resp.message);
            } else {
                alert("Producto borrado correctamente");
                buscar();
            }
        }
    }

    const columnas = [
        {
            titulo:"Código",
            atributo:"codigo"
        },
        {
            titulo:"Descripción",
            atributo:"descripcion",
            className:"text-truncate"
        },
        {
            titulo:"Cant. Bultos",
            atributo:"cantidad_x_bulto",
            className:"d-none d-md-table-cell max-width-7-em"
        },
        {
            titulo:"Precio Unitario",
            atributo:"precio_unitario",
            className:"col-importe-small",
            funcion: formatNumber
        },
        {
            titulo : "Lista",
            atributo : "nombre_lista",
            className:"d-none d-md-table-cell"
        },
        {
            titulo:"Estado",
            atributo:"estado"
        }
    ]

    const columnasExcel = [
        {
            titulo:"Código",
            atributo:"codigo"
        },
        {
            titulo:"Descripción",
            atributo:"descripcion"
        },
        {
            titulo:"Cantidad x Bulto",
            atributo:"cantidad_x_bulto"
        },
        {
            titulo : "Lista",
            atributo : "nombre_lista"
        },
        {
            titulo:"Precio Unitario",
            atributo:"precio_unitario"
        }
    ]

    return <>
        <BreadcrumbDatos active="Productos - Consulta"/>
        <Form>
            <Row className="align-items-center">
                <Col xs="auto" md="4">
                    <InputGroup className="mb-2">
                    <Form.Label htmlFor="selMarca" visuallyHidden>
                        Marca
                    </Form.Label>
                    <Form.Select 
                        id="selMarca" value={marca}
                        onChange={(e) => {setMarca(e.target.value);/*buscar(true)*/}}>
                        <option value="">Seleccione marca...</option>
                        {marcas.map((m) => <option key={m.marca_id} value={m.marca_id}>{m.nombre}</option>)}
                    </Form.Select>
                    </InputGroup>
                </Col>
                <Col xs="auto" md="4">
                    <InputGroup className="mb-2">
                    <Form.Label htmlFor="txtNombre" visuallyHidden>
                        Nombre
                    </Form.Label>
                    <Form.Control
                        id="txtNombre" 
                        value={nombre} onChange={(e) => {setNombre(e.target.value)}}
                        placeholder="Nombre a buscar..."
                    />
                    <Button id="btnBuscar" onClick={() => buscar()}>
                        Buscar
                    </Button>
                    </InputGroup>
                </Col>
                <Col xs="auto">
                    <Form.Check
                        type="checkbox"
                        id="chkIncluirInactivos"
                        checked={incluirInactivos}
                        className="mb-2"
                        label="Incluir inactivos"
                        onChange={(e) => {setIncluirInactivos(e.target.checked)}}
                    />
                </Col>
            </Row>
            {error!==''?
                <Row>
                    <Col xs="auto">
                        <Alert variant="danger" key="danger">{error}</Alert>
                    </Col>
                </Row>:
                <></>
            }
        </Form>
        {cargando?<Cargando></Cargando>:<></>}
        <MaoTable 
            columnas={columnas} 
            datos={productos} 
            colId="producto_id"
            colEstado="estado"
            colNombre="descripcion"
            borrar={borrar} 
            editar={editar}>
        </MaoTable>
        <Row>
            <Col xs="auto">
                <Button id="btnNuevo" onClick={nuevo}>Nuevo</Button>
            </Col>
            <Col xs="auto">
                <Button id="btnImportar" onClick={importar}>Importar</Button>
            </Col>
            <Col xs="auto">
                <ButtonExportarExcel data={productos} 
                    fileName={`listaprecios-${nombreMarca}`}
                    noHayDatosMessage="Debe seleccionar una marca"
                    columnas={columnasExcel}>
                </ButtonExportarExcel>
            </Col>
            <Col xs="auto">
                <Button id="btnExportarPDF" onClick={exportarPDF}
                    title="Exportar a PDF">
                    Exportar <FaFilePdf></FaFilePdf>
                </Button>
            </Col>
        </Row>
    </>
}